import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import * as fromCommon from '../reducers/common.reducer';

export const selectCommonState = createFeatureSelector<fromCommon.State>(
  fromCommon.commonFeatureKey
);

export const isLoading = (state: fromCommon.State): boolean => state.loading;
export const isLoaded = (state: fromCommon.State): boolean => state.loaded;

export const selectIsLoading: MemoizedSelector<object, boolean> = createSelector(selectCommonState, isLoading);
export const selectIsLoaded: MemoizedSelector<object, boolean> = createSelector(selectCommonState, isLoaded);

export const selectCommonById = (id: string) => createSelector(selectCommonState, (state: fromCommon.State) => {
  if (id){
    return state.common.find((a)=> a.id === id);
  } else {
    return null;
  }
});